import React from 'react';
import c from 'classnames';

import { SearchPagination } from '@uncinc/react-searchkit';

import Icon from '../../Icon';

export interface SearchForumCategoriesPaginationProps {
  className?: string;
}

const SearchForumCategoriesPagination: React.FC<SearchForumCategoriesPaginationProps> = (props) => {
  const { className } = props;

  const classNames = c('SearchForumCategories__Pagination', className);

  return (
    <div className={classNames}>
      <SearchPagination
        pageRangeDisplayed={3}
        previousLabel={(
          <Icon icon="chevron" orientation="left" />
        )}
        nextLabel={(
          <Icon icon="chevron" />
        )}
      />
    </div>
  );
};

export default SearchForumCategoriesPagination;
